import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { NotificationsActions } from '../actions/notifications.actions';
import { NotificationsService } from '../../shared/services/notifications.service';

@Injectable()
export class NotificationsEffects {

  constructor(
    private actions$: Actions,
    private notificationsService: NotificationsService,
  ) { }

  loadUserNotifications$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(NotificationsActions.loadUserNotifications),
      mergeMap((payload) =>
        this.notificationsService.getUserNotificationsByProperty(payload.propertyId)
          .pipe(
            map((responsePayload) => NotificationsActions.loadUserNotificationsSuccess({ data: responsePayload })),
            catchError(error => of(NotificationsActions.loadUserNotificationsFailure({ error }))))
      )
    );
  });

  setAllUserNotificationsAsRead$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(NotificationsActions.setUserNotificationsAsRead),
      mergeMap((payload) =>
        this.notificationsService.setAllUserNotificationsAsRead(payload.propertyId)
          .pipe(
            map(() => NotificationsActions.setUserNotificationsAsReadSuccess()),
            catchError(error => of(NotificationsActions.setUserNotificationsAsReadFailure({ error }))))
      )
    );
  });
}
